<template>
  <VisionFourFilters :loading="loading" @filter="onFilter" />
  <div ref="chart" />
</template>

<script>
import VisionFourFilters from './VisionFourFilters.vue';
import { getVisionFourCharts } from '../visionFourService';
import chart from '@/modules/shared/chartMixin';

export default {
  components: { VisionFourFilters },
  mixins: [chart],
  methods: {
    async getCharts(filters) { return await getVisionFourCharts(filters); },
  },
};
</script>
